export const GradientDivider: React.FC = () => (
  <div className='relative flex h-px w-full items-center'>
    <div className='pointer-events-none absolute left-0 top-0 h-0.5 w-1/6 bg-gradient-to-r from-white to-transparent' />
    <div className='h-px w-full bg-neutral-100' />
    <div className='pointer-events-none absolute right-0 top-0 h-0.5 w-1/6 bg-gradient-to-l from-white to-transparent' />
  </div>
);
